import React from "react";
import { useTranslation } from "react-i18next";

const BudgetInsights = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row budgets-insights-row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11">
          <p>{t("dashboard.content.line1")}</p>
          <p>{t("dashboard.content.line2")}</p>
          <p>
            <strong>{t("dashboard.content.subTitle")} </strong>
          </p>
          <p>{t("dashboard.content.line3")}</p>
        </div>
      </div>
    </>
  );
};

export default BudgetInsights;
